import React from 'react'
import classes from "./styles/faq.module.css";
import Faq1 from './faq/Faq1';
import Faq2 from './faq/Faq2';
import Faq3 from './faq/Faq3';
import Faq4 from './faq/Faq4';
import img from "../../assets/about/Faq.jpeg";
const Faq = () => {
    
  return (
    <div className={classes.Container}>
      <div className={classes.leftCon}>
        <img src={img} alt='online fitness' />
      </div>
      <div className={classes.rightCon}>
        <h2 className={classes.title}>Frequently Asked Questions</h2>
      <div className={classes.innerCon}>
            <Faq1/>
            <Faq2/>
            <Faq3/>
            <Faq4/>
        </div>
      </div>
    </div>
  )
}

export default Faq;
